export enum MerchantDetailAction {
  APPROVE_BY_COMMERCIAL = 'APPROVE_BY_COMMERCIAL',
  APPROVE_BY_RISK = 'APPROVE_BY_RISK',
  SUSPEND_ACTION = 'SUSPEND_ACTION',
  BAN_ACTION = 'BAN_ACTION',
  REACTIVATE_ACTION = 'REACTIVATE_ACTION',
}
